import { render, staticRenderFns } from "./myArticle.vue?vue&type=template&id=74547c45&scoped=true&"
import script from "./myArticle.vue?vue&type=script&lang=js&"
export * from "./myArticle.vue?vue&type=script&lang=js&"
import style0 from "./myArticle.vue?vue&type=style&index=0&id=74547c45&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74547c45",
  null
  
)

export default component.exports